// extracted by mini-css-extract-plugin
export default {"notificationBell":"sMqCk9F0K2QtIBiOv9YG","notificationBellBadge":"EniO5sKxZiEeaJe00wa7"};